import React, { useState, useContext } from "react";
import * as FiIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../../helper/auth";
import { ReactComponent as BuyWaterSvg } from "../../svgs/buywater.svg";
import { ReactComponent as LogInSvg } from "../../svgs/login.svg";
import { ReactComponent as LogoutSvg } from "../../svgs/logout.svg";
import { ReactComponent as ReportLeakagSvg } from "../../svgs/reportLeakage.svg";
import { ReactComponent as TransactionsSvg } from "../../svgs/transaction.svg";
import { LogContent } from "../../helper/context";
import { routes } from "../../helper/misc";
import Logo from "../GeneralComponents/Logo";

function Navbar() {
  const auth = useAuth();
  const [clickNav, setClickNav] = useState(false);
  const { displayMeta, setDisplayMeta } = useContext(LogContent);
  const handleClick = () => {
    setClickNav(false);
  };

  let activeStyle = {
    borderBottom: "2px black solid",
  };

  let inActiveStyle = {
    borderBottom: "2px black transparent",
  };

  return (
    <div className="!max-w-[1280px] px-4 md:px-10 mx-auto">
      <nav
        className={
          "lg:mt-3 flex lg:hidden medium:hidden xl:hidden justify-between w-full pt-5 lg:pb-3"
        }
      >
        <Link to={"/"} className="flex items-center">
          <div className="pb-1">
            <Logo />
          </div>
        </Link>
        <div
          className={"block self-center mr-4"}
          onClick={() => {
            setClickNav(true);
          }}
        >
          <FiIcons.FaBars />
        </div>
      </nav>
      <div
        className={
          clickNav
            ? "absolute top-[5%] right-0 bg-white border rounded-2xl z-20 px-3 py-2"
            : "hidden"
        }
      >
        <AiIcons.AiOutlineClose
          className="mt-2 ml-[80%]"
          onClick={handleClick}
        />
        <div className="text-sm font-medium pt-2">
          <Link to="/buy-water">
            <div className="flex mb-5">
              <span className="mr-[18px]">
                <BuyWaterSvg className="fill-black" />
              </span>
              <h4>BuyWater</h4>
            </div>
          </Link>
          <Link to="/transactions">
            <div className="flex mb-5">
              <span className="mr-[23.5px]">
                <TransactionsSvg />
              </span>
              <h4>Transactions</h4>
            </div>
          </Link>
          <Link to="/report-leakage">
            <div className="flex mb-5">
              <span className="mr-[18px]">
                <ReportLeakagSvg />
              </span>
              <h4>Report Leakage</h4>
            </div>
          </Link>
          <Link onClick={handleClick} to={routes.contact}>
            <div className="flex mb-5">
              <span className="mr-[18px]">
                <LogInSvg />
              </span>
              <h4>Contact us</h4>
            </div>
          </Link>
          <Link onClick={handleClick} to={routes.about}>
            <div className="flex mb-5">
              <span className="mr-[18px]">
                <LogInSvg />
              </span>
              <h4>About</h4>
            </div>
          </Link>
          {!auth.user ? (
            <Link to="/login">
              <div className="flex mb-5">
                <span className="mr-[21px]">
                  <LogInSvg className="fill-black" />
                </span>
                <h4>Log in</h4>
              </div>
            </Link>
          ) : (
            <div
              role="button"
              onClick={() => {
                setDisplayMeta(!displayMeta);
              }}
              className="flex"
            >
              <span className="mr-[18px]">
                <LogoutSvg />
              </span>
              <h4>Log out</h4>
            </div>
          )}
        </div>
      </div>
      <header className="hidden md:hidden lg:flex justify-between mt-4 items-center">
        <Link to="/">
          <div className="flex items-center">
            <Logo width={100} height={100} />
          </div>
        </Link>
        <div className="md:ml-[20%] ml-[30%]">
          <ul className="flex">
            <li className="text-sm font-medium mr-12 w-24">
              <NavLink
                style={({ isActive }) =>
                  isActive ? activeStyle : inActiveStyle
                }
                to="/about"
              >
                About Us
              </NavLink>
            </li>
            <li className="text-sm font-medium mr-12 w-24">
              <NavLink
                style={({ isActive }) =>
                  isActive ? activeStyle : inActiveStyle
                }
                to="/contact"
              >
                Contact Us
              </NavLink>
            </li>
            <li
              className={
                !auth.user
                  ? "text-sm hover:border-b-2 hover:border-black font-medium mr-6 w-24"
                  : "hidden"
              }
            >
              <NavLink
                style={({ isActive }) =>
                  isActive ? activeStyle : inActiveStyle
                }
                to="/login"
              >
                Sign In
              </NavLink>
            </li>
          </ul>
        </div>
        {!auth.user && (
          <Link to="/signup">
            <button className="bg-pw-blue text-white font-bold text-sm rounded-3xl py-[17px] px-12 md:py-3 md:px-8 mr-4 hover:bg-white hover:border-2 hover:border-pw-blue hover:text-pw-blue">
              Get Started
            </button>
          </Link>
        )}
      </header>
    </div>
  );
}

export default Navbar;
